import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  inlineMenu: {
    display: 'flex',
  },
  inlineMenuWrapper: {
    [Theme.breakpoints.up('xs')]: {
      paddingBottom: '10px !important',
    },
    [Theme.breakpoints.up('sm')]: {
      paddingBottom: '3px !important',
    },
    [Theme.breakpoints.up('md')]: {
      paddingBottom: '3px !important',
    },
    [Theme.breakpoints.up('lg')]: {
      paddingBottom: '3px !important',
      paddingLeft: '15px !important',
    },
  },
}));

export default useStyles;
